module.exports = __webpack_public_path__ + "img/mdb.24a6fdb9.svg";